import Tabs from "../../UI/Tabs/Tabs";
import TabsItem from "../../UI/Tabs/TabsItem";

export default () => {
  return (
    <Tabs>
      <TabsItem to="/admin/contracts" activeClassName="Tabs__item_state_active">
        Контракты
      </TabsItem>
      <TabsItem to="/admin/new-contract" activeClassName="Tabs__item_state_active">
        Добавить
      </TabsItem>
      <TabsItem to="/admin/service123" activeClassName="Tabs__item_state_active">
        База
      </TabsItem>
    </Tabs>
  );
};
